import { memo } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileText } from "lucide-react";

interface DocumentSelectionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelectDocument: (id: string) => void;
}

export const DocumentSelectionDialog = memo(function DocumentSelectionDialog({
  open, 
  onOpenChange, 
  onSelectDocument 
}: DocumentSelectionDialogProps) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Generate a Document</DialogTitle>
          <DialogDescription>
            Create succession planning documents from templates
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4 py-6">
          <div className="bg-secondary rounded-full p-4">
            <FileText className="h-10 w-10 text-primary" />
          </div>
          <p className="text-sm text-muted-foreground text-center">
            Head to the Documents page to generate or upload documents.
          </p>
          <Button onClick={() => { onOpenChange(false); navigate('/documents'); }}>
            Go to Documents
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
});

DocumentSelectionDialog.displayName = "DocumentSelectionDialog";
